<template>
    <div class="mt-[44px] grid-cols-layout pb-5 lg:grid">
        <div class="mb-6 lg:mb-0 lg:mt-4">
            <h3
                class="gray-800 mb-[5px] text-lg font-medium leading-normal tracking-small"
            >
                API token
            </h3>
            <p class="max-w-xs text-sm text-gray-500">
                {{ $t("vue.your_rhizom_api_token") }}
            </p>
        </div>

        <div class="mx-auto w-full rounded-md bg-white shadow-card lg:mx-0">
            <div class="mt-2 flex w-full p-6 border-b border-gray-200">
                <div class="text-gray-500 sm:w-2/12">
                    {{ $t("vue.api_token") }}
                </div>
                <div
                    class="ml-2 flex max-w-xs overflow-hidden text-clip whitespace-nowrap text-gray-800 sm:ml-0 sm:w-10/12"
                >
                    <span v-for="key in globalProps.user.token" :key="key">
                        •
                    </span>
                </div>
            </div>

            <div class="flex justify-end">
                <div class="my-3 pr-6">
                    <AtomicButton
                        type="submit"
                        color="yellow"
                        size="sm"
                        @click="showCopyTokenModal = true"
                    >
                        {{ $t("vue.show_token") }}
                    </AtomicButton>
                </div>
            </div>
        </div>

        <CopyTokenToClipboard
            v-if="showCopyTokenModal"
            @close="showCopyTokenModal = false"
        />
    </div>
</template>

<script lang="ts" setup>
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";

const showCopyTokenModal = ref(false);
const globalProps = computed(() => usePage<IRhizomPageProps>().props);
</script>
